export const eLearningUrl = new URL('https://rise.articulate.com/share/3rwO1Ym6DRspJdbvA5Ad8G11iU1UK6od');

export class BlightAIIdentifiers {
  private static readonly identifier = 'Blight';

  static get clickTable() {
    return `${this.identifier}.ClickTable`;
  }

  static get clickInsights() {
    return `${this.identifier}.ClickInsights`;
  }

  static get addActionMyArable() {
    return `${this.identifier}.AddAction_MyArable`;
  }

  static get addActionOverview() {
    return `${this.identifier}.AddAction_Overview`;
  }

  static get selectPreventive() {
    return `${this.identifier}.SelectPreventive`;
  }

  static get selectCurative() {
    return `${this.identifier}.SelectCurative`;
  }

  static get selectStop() {
    return `${this.identifier}.SelectStop`;
  }

  static get selectIrrigation() {
    return `${this.identifier}.SelectIrrigation`;
  }

  static get deleteSpray() {
    return `${this.identifier}.DeleteSpray`;
  }

  static get viewAdvice() {
    return `${this.identifier}.ViewAdvice`;
  }

  static get recalc() {
    return `${this.identifier}.Recalc`;
  }

  static get delayFirst() {
    return `${this.identifier}.Delay1st`;
  }

  static get changeEmergence() {
    return `${this.identifier}.ChangeEmergence`;
  }
}
